import { render, staticRenderFns } from "./InitConfigCourseCard.vue?vue&type=template&id=82fd32a2&scoped=true&"
import script from "./InitConfigCourseCard.vue?vue&type=script&lang=js&"
export * from "./InitConfigCourseCard.vue?vue&type=script&lang=js&"
import style0 from "./InitConfigCourseCard.vue?vue&type=style&index=0&id=82fd32a2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "82fd32a2",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VCardTitle } from 'vuetify/lib/components/VCard';
installComponents(component, {VCard,VCardText,VCardTitle})
